/**
 * A state said in words (proposal 10): "⏰ Overdue 1 day · chase",
 * "⏳ waiting 1 day · reminder Mon", "✓ Answered · unread". The tone only
 * repeats what the words say.
 */
import type { StateWord } from './stateWords';
import styles from './StateWordPill.module.css';

export default function StateWordPill({ word }: { word: StateWord }) {
  return (
    <span className={styles.pill} data-tone={word.tone} data-testid="state-word">
      {word.text}
    </span>
  );
}
